export const ERROR_MESSAGES = {
  LOCAL_STORAGE_DISABLED: "Local storage is disabled",
  INVALID_USER: "User does not have access to this order",
  MEMBERSHIP_INVOICED:
    "This membership has been invoiced by the venue, the membership needs to be paid through the invoice. If you haven't received your invoice, please reach out to the venue.",
} as const;
